import React from 'react';
import { Card, Notification } from "rbx";
import Controls from '../../components/Controls/Controls';

const AppForm = (props) => {
  const { 
    newRecord=false, 
    editRecord=false, 
    status, 
    stateButton, 
    values, 
    handleInputChange, 
    handleSubmit, 
    handleClickBack } = props;

  return (
    <form onSubmit={handleSubmit}>
      <Card>
        <Card.Header>
          <Card.Header.Title>{newRecord ? 'Registrar Usuário App' : 'Editar Usuário'}</Card.Header.Title>
        </Card.Header>
        <Card.Content>
          { status!=='' && <Notification color={status[0]}>{status[1]}</Notification> }
          <Controls.CpfCnpjField 
            label="CPF ou CNPJ"
            name="cpf_cnpj"
            placeholder='123.456.789-01'
            value={values.cpf_cnpj}
            onChange={handleInputChange}
            focus={true}
            required
          />
          <Controls.TextField 
            label="Nome"
            name="name"
            placeholder='Nome completo'
            value={values.name}
            onChange={handleInputChange}
            required
          />
          <Controls.TextField 
            label="Email"
            name="email"
            placeholder='nome@email.com'
            value={values.email}
            onChange={handleInputChange}
            required
          />
          <Controls.TextFieldMask
            label="Data de Nascimento"
            name="birthday"
            mask='99/99/9999'
            placeholder='__/__/____'
            value={values.birthday}
            onChange={handleInputChange}
            required
          />
          <Controls.PhoneField 
            label="Telefone"
            name="phone"
            placeholder='(__) ____-____'
            value={values.phone}
            onChange={handleInputChange}
            required
          />
          <Controls.PasswordField 
            label={newRecord ? 'Senha:' : 'Senha do ADM'}
            name="password"
            value={values.password}
            onChange={handleInputChange}
            required
          />
          <Controls.ActionButtons
            linkName="Cancelar" 
            handleClickBack={handleClickBack} 
            buttonState={stateButton} 
            buttonName={newRecord ? 'Registrar' : 'Atualizar'}
          />
        </Card.Content>
      </Card>
      {
        (editRecord) &&
        <>
          <br />
          <Card>
            <Card.Content>
              { status!=='' && <Notification color={status[0]}>{status[1]}</Notification> }
              <Controls.PasswordField 
                label="Nova senha do Usuário"
                name="passwordNew"
                placeholder="Deixe em branco para não trocar a senha"
                value={values.passwordNew}
                onChange={handleInputChange}
              />
              <Controls.PasswordField 
                label="Confirme a nova senha"
                name="passwordConfirmation"
                placeholder="Deixe em branco para não trocar a senha"
                value={values.passwordConfirmation}
                onChange={handleInputChange}
              />
              <Controls.ActionButtons
                linkName="Cancelar" 
                handleClickBack={handleClickBack}
                buttonState={stateButton} 
                buttonName='Atualizar'
              />
            </Card.Content>
          </Card>
        </>
      }
    </form>
  )

}

export default AppForm;

